import { GrowProjectsResponse, InyovaGrowPercentages, InyovaGrowRisk, InyovaGrowSubmit, InyovaGrowSurveyQuestion } from '@inyova/grow';
import { GrowAccount } from '@inyova/models';

import { createAction, props } from '@ngrx/store';

export const createGrowAccount = createAction('[Grow] Create account');
export const createGrowAccountSuccess = createAction('[Grow] Create account success', props<{ data: GrowAccount }>());
export const createGrowAccountFail = createAction('[Grow] Create account fail');

export const getGrowAccount = createAction('[Grow] Get the grow account details');
export const getGrowAccountSuccess = createAction('[Grow] Get the grow account details success', props<{ data: GrowAccount }>());
export const getGrowAccountFail = createAction('[Grow] Get the grow account details fail');

export const getGrowRisk = createAction('[Grow] Get Grow risk', props<{ language: string }>());
export const getGrowRiskSuccess = createAction(
  '[Grow] Get Grow risk success',
  props<{ data: InyovaGrowRisk; percentages: InyovaGrowPercentages; language: string }>()
);
export const getGrowRiskFail = createAction('[Grow] Get Inyova Grow risk fail');

export const checkGrowRiskProfile = createAction(
  '[Grow] Check Inyova grow risk profile',
  props<{ answers: InyovaGrowSurveyQuestion[]; availableAssets: number; initInvest: number }>()
);
export const checkGrowRiskProfileSuccess = createAction('[Grow] Check Grow risk profile success', props<{ data: InyovaGrowPercentages }>());
export const checkGrowRiskProfileFail = createAction('[Grow] Check Grow risk profile fail');

export const submitGrowRisk = createAction('[Grow] Submit Grow risk', props<{ data: InyovaGrowSubmit; id: string }>());
export const submitGrowRiskSuccess = createAction('[Grow] Submit Grow risk success', props<{ id: string }>());
export const submitGrowRiskFail = createAction('[Grow] Submit Grow risk fail');

export const markGrowProject = createAction('[Grow] Mark Grow project', props<{ projectId: string }>());
export const markGrowProjectSuccess = createAction('[Grow] Mark Grow project success', props<{ projectId: string }>());

export const unmarkGrowProject = createAction('[Grow] Unmark Grow project', props<{ projectId: string }>());
export const unmarkGrowProjectSuccess = createAction('[Grow] Unmark Grow project success', props<{ projectId: string }>());

export const getGrowProjects = createAction('[Grow] Get Grow projects');
export const getGrowProjectsSuccess = createAction('[Grow] Get Grow projects success', props<GrowProjectsResponse>());
export const getGrowProjectsFail = createAction('[Grow] Get Grow projects fail');
